import { csatStore as e } from "./csatStore.mjs";
import { csatQueryKeys as t } from "./queryKeys.mjs";
import { useMutation as n, useQueryClient as r } from "@maat/store-hooks";
import { csatApi as i } from "@maat/api-csat";
//#region src/useSubmitCsatMutation.ts
var a = () => {
	let a = r();
	return n({
		mutationFn: (e) => i.submitResponse(e.payload),
		onSuccess: (n, { feature: r }) => {
			a.setQueryData(t.eligibility(r), { eligible: !1 }), e.close();
		}
	});
};
//#endregion
export { a as useSubmitCsatMutation };
